import { getToken } from "../../../shared/utils/common";


export class CommandListTemplates {
    async run(folderId: number) {
       
            const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/content/${folderId}/ad_templates/`
            try {
                const response = await fetch(url, {
                    method: "GET",
                    headers: {'Content-Type': 'application/json', "Authorization": `Token ${getToken()} `},
                    })
                .then(response =>  response.json())
                .then(json => json)
                .catch(err => console.log(err));
                if(response) {
                    return response;
                }
            } catch (error) {
                console.error('Error fetching data:', error);
                throw error;
            }
        }

}
